import TextField from '@mui/material/TextField';
import { type FC, useEffect, useState } from 'react';

interface TextFieldDebounceProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  debounceTime?: number;
  size?: 'small' | 'medium';
}

const TextFieldDebounce: FC<TextFieldDebounceProps> = ({
  value,
  onChange,
  placeholder = '',
  debounceTime = 600,
  size = 'small',
}) => {
  const [currentValue, setCurrentValue] = useState<string>(value);

  useEffect(() => {
    setCurrentValue(value);
  }, [value]);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      if (currentValue !== value) {
        onChange(currentValue);
      }
    }, debounceTime);

    return () => clearTimeout(debounceTimeout);
  }, [currentValue, onChange, debounceTime, value]);

  return (
    <TextField
      type="text"
      placeholder={placeholder}
      size={size}
      onChange={(e) => setCurrentValue(e.target.value)}
      value={currentValue}
      slotProps={{
        input: {
          sx: {
            pr: 0.5,
            '& .MuiInputBase-input': {
              fontSize: '14px',
              fontWeight: 500,
              '&::placeholder': {
                color: 'text.secondary',
                opacity: 0.8,
              },
            },
          },
        },
      }}
    />
  );
};

export default TextFieldDebounce;
